import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        flexDirection: "column",
        height: "130px",
        width: "155px",
        borderRadius: "4px",
        backgroundColor: "#E4F5EC",
        padding: "14px",
    },
    firstRow_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    secondRow_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        marginTop: "14px",
    },
    tempField: {
        color: "#353535",
        fontSize: "32px",
        fontWeight: 300,
        letterSpacing: 0,
        borderBottom: "1.4px solid rgba(0, 131, 62, .3)",
    },
    month: {
        color: "#353535",
        fontSize: "14px",
        letterSpacing: 0,
    },
    button: {
        cursor: "pointer",
    },
    //------------------------------ Mobile --------------------------------
    mobile_container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "64px",
        width: "100%",
        borderRadius: "4px",
        backgroundColor: "#E4F5EC",
        padding: "14px",
    },
    firstCol: {},
    secondCol: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    thirdCol: {},
    mobile_month: {
        color: "#353535",
        fontSize: "18px",
        letterSpacing: 0,
        width: "50px",
    },
    mobile_button: {
        margin: "0px 14px",
    },
}));

export default useStyles;
